// Platform logo component used across the Navbar, AuthModal, Footer, and more.
// Renders the LegalGuardian shield mark as a circular image — import this
// anywhere you need the logo instead of hardcoding an <img> tag.
import logoImage from "../image/logo-round.png";

export default function Logo({ width = 36, height = 36, className = "" }) {
  return (
    <img
      src={logoImage}
      alt="Kanoon Talk logo"
      className={`app-logo-img ${className}`}
      width={width}
      height={height}
    />
  );
}
